$(document).ready(function () {
  ("use strict");

  // Menú: afegim botó i ocultem menú quan hi ha js
  $("#menu")
    .before(
      '<button class="hamburger hamburger--spring" type="button" aria-expanded="false" aria-controls="menu"><span class="hamburger-box"><span class="hamburger-inner"></span></span><span class="is-sr-only">Menu</span></button>'
    )
    .attr("hidden", "true");

  // ----
  // menú (https://polypane.rocks/blog/the-perfect-responsive-menu-2019/)
  // ----
  var toggleMenu = document.querySelector(".navigation button");
  var menu = document.querySelector("#menu");

  if (toggleMenu) {
    toggleMenu.addEventListener("click", function () {
      var open = JSON.parse(toggleMenu.getAttribute("aria-expanded"));
      toggleMenu.setAttribute("aria-expanded", !open);
      menu.hidden = !menu.hidden;
    });
  }

  $(".hamburger").on("click", function () {
    // afegir classe al botó
    $(this).toggleClass("is-active");
    // afegir classe al body
    // $("body").toggleClass("js-menu-open");
  });

  // -------------------------------
  // Menú principal amb desplegables (https://www.w3.org/WAI/tutorials/menus/flyout/#use-button-as-toggle)
  // -------------------------------

  // function hasClass(el, className) {
  //   return el.classList ? el.classList.contains(className) : new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
  // }

  // var menuItems1 = document.querySelectorAll('li.has-submenu');
  // var timer1, timer2;

  // var parseHTML = function(str) {
  //     var tmp = document.implementation.createHTMLDocument();
  //     tmp.body.innerHTML = str;
  //     return tmp.body.children;
  // };

  // Array.prototype.forEach.call(menuItems1, function(el, i){
  //     var activatingA = el.querySelector('a');
  //     var btn = '<button type="button"><span class="is-sr-only">Mostra el submenú de “' + activatingA.text + '”</span></button>';
  //     activatingA.insertAdjacentHTML('afterend', btn);

  //     // Handle hover event for non-touch devices
  //     el.addEventListener("mouseover", function(event){
  //         this.classList.add("open");
  //         this.querySelector('a').setAttribute('aria-expanded', "true");
  //         this.querySelector('button').setAttribute('aria-expanded', "true");
  //         clearTimeout(timer1);
  //     });

  //     el.addEventListener("mouseout", function(event){
  //         timer1 = setTimeout(function(){
  //             var openMenu = document.querySelector('.has-submenu.open');
  //             if (openMenu) {
  //                 openMenu.querySelector('a').setAttribute('aria-expanded', "false");
  //                 openMenu.querySelector('button').setAttribute('aria-expanded', "false");
  //                 openMenu.classList.remove("open");
  //             }
  //         }, 500);
  //     });

  //     // Handle click and touchstart events for touch devices
  //     el.querySelector('button').addEventListener("click", function(event){
  //         event.preventDefault();
  //         toggleSubmenu(el);
  //     });

  //     el.querySelector('button').addEventListener("touchstart", function(event){
  //         event.preventDefault();
  //         toggleSubmenu(el);
  //     });

  //     var links = el.querySelectorAll('a');
  //     Array.prototype.forEach.call(links, function(link, i){
  //         link.addEventListener("focus", function() {
  //             if (timer2) {
  //                 clearTimeout(timer2);
  //                 timer2 = null;
  //             }
  //         });
  //         link.addEventListener("blur", function(event) {
  //             timer2 = setTimeout(function () {
  //                 var openNav = document.querySelector(".has-submenu.open")
  //                 if (openNav) {
  //                     openNav.className = "has-submenu";
  //                     openNav.querySelector('a').setAttribute('aria-expanded', "false");
  //                     openNav.querySelector('button').setAttribute('aria-expanded', "false");
  //                 }
  //             }, 10);
  //         });
  //     });
  // });

  // function toggleSubmenu(el) {
  //     var isOpen = hasClass(el, "open");

  //     // Close any other open submenus
  //     var allMenus = document.querySelectorAll('li.has-submenu');
  //     Array.prototype.forEach.call(allMenus, function(item){
  //         item.classList.remove("open");
  //         item.querySelector('a').setAttribute('aria-expanded', "false");
  //         item.querySelector('button').setAttribute('aria-expanded', "false");
  //     });

  //     // Open the clicked/touched submenu if it was not already open
  //     if (!isOpen) {
  //         el.classList.add("open");
  //         el.querySelector('a').setAttribute('aria-expanded', "true");
  //         el.querySelector('button').setAttribute('aria-expanded', "true");
  //     }
  // }

  // ---------
  // skip link (https://www.bignerdranch.com/blog/web-accessibility-skip-navigation-links/)
  // ---------

  // bind a click event to the 'skip' link
  $(".skip-link").click(function (event) {
    // strip the leading hash and declare
    // the content we're skipping to
    var skipTo = "#" + this.href.split("#")[1];

    // Setting 'tabindex' to -1 takes an element out of normal
    // tab flow but allows it to be focused via javascript
    $(skipTo)
      .attr("tabindex", -1)
      .on("blur focusout", function () {
        // when focus leaves this element,
        // remove the tabindex attribute
        $(this).removeAttr("tabindex");
      })
      .focus(); // focus on the content container
  });

  // ----------
  // scroll top
  // ----------
  $(window).scroll(function () {
    if ($(this).scrollTop() > 400) {
      $(".scrolltop").addClass("visible");
    } else {
      $(".scrolltop").removeClass("visible");
    }
  });

  // ------
  // Slider
  // ------
  $('.slider').slick({
    dots: true,
    arrows: false,
    autoplay: false,
    // autoplaySpeed: 5000,
    fade: true,
  });

  // --------------
  // Navegació fixa
  // --------------
  let lastScrollTop = 0; // Variable per controlar el desplaçament anterior

  $(window).on('scroll', function() {

      const scrollTop = $(this).scrollTop(); // Obtenir la posició actual del scroll

      if (scrollTop >= 70) {
          // Si el desplaçament és major o igual a 70px, afegir la classe
          $('.main-header').addClass('fixed');
      } else {
          // Si el desplaçament és menor a 70px, eliminar la classe
          $('.main-header').removeClass('fixed');
      }

      lastScrollTop = scrollTop; // Actualitzar la posició de desplaçament anterior
  });


   // --------
  // Counters https://github.com/srexi/purecounterjs
  // --------
  new PureCounter({
    // selector: '.purecounter',
    // start: 0,
    // end: 100,
    // duration: 2,
    // delay: 10,
    // once: true,
    // repeat: false,
    // decimals: 0,
    legacy: false,
    // filesizing: false,
    // currency: false,
    separator: true,
  });

  // -----------
  // File upload
  // -----------
  $('input[type="file"]').change(function () {
    var fileName = '';
    var $fileName = $(this).siblings('.file-name');
    if (this.files && this.files[0]) {
      fileName = this.files[0].name;
      $fileName.addClass('has-file');
    } else {
      $fileName.removeClass('has-file');
    }
    $fileName.text(fileName);
  });

  // ----------------------
  // File upload - Clear button
  // ----------------------
  $('input[type="file"]').each(function () {
    const $input = $(this);
    const $fileContainer = $input.closest('.file');

    // Afegeix el botó fora del label, dins del contenidor .file
    const $resetBtn = $(`
      <button type="button" class="clearButton" aria-label="Esborra l'arxiu">
          <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false">
              <path d="M6 6L18 18M18 6L6 18"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"/>
          </svg>
      </button>
    `);
    $fileContainer.append($resetBtn);

    if($input.val() == '') {
      $resetBtn.hide();
    }

    // Mostrar el botó si hi ha fitxer
    $input.on('change', function () {
      if (this.files.length > 0) {
        $resetBtn.show();
      } else {
        $resetBtn.hide();
      }
    });

    // Acció del botó
    $resetBtn.on('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      $input.val('');       // Esborra el fitxer
      var $fileName = $input.siblings('.file-name');
      $fileName.text('Selecciona un fitxer'); // Restaura el text
      $fileName.removeClass('has-file'); // Elimina la classe
      $resetBtn.hide();     // Amaga el botó
      $input.focus();
    });
  });

  document.querySelectorAll('video').forEach(function (v) {
    var src = v.currentSrc || v.querySelector('source').src;
    var title = src.split('/').pop();
    var sent = {};
    function ev(name, extra) {
      gtag('event', name, Object.assign({ video_provider: 'html5', video_title: title, video_url: src }, extra || {}));
    }
    v.addEventListener('play', function () { if (!sent.start) { sent.start = 1; ev('video_start'); } });
    v.addEventListener('timeupdate', function () {
    var p = Math.floor(v.currentTime / v.duration * 100);
    [25, 50, 75].forEach(function (m) { if (p >= m && !sent[m]) { sent[m] = 1; ev('video_progress', { video_percent: m }); } });
    });
    v.addEventListener('ended', function () { if (!sent.end) { sent.end = 1; ev('video_complete'); } });
  });

});

// Dates Inici/Fi cercador convocatòries
document.addEventListener("DOMContentLoaded", () => {
  const startDateInput = document.getElementById("date_start");
  const endDateInput = document.getElementById("date_end");
  if (startDateInput && endDateInput) {

    // Quan es modifica la data d'inici
    startDateInput.addEventListener("change", () => {
        const startDate = new Date(startDateInput.value);
        const endDate = new Date(endDateInput.value);

        // Si la data d'inici supera la de final, ajustem la de final
        if (startDate && endDate && startDate > endDate) {
            endDateInput.value = startDateInput.value;
        }

        // Ajustem el valor mínim per la data de final
        endDateInput.min = startDateInput.value;
    });

    // Quan es modifica la data de final
    endDateInput.addEventListener("change", () => {
        const startDate = new Date(startDateInput.value);
        const endDate = new Date(endDateInput.value);

        // Si la data de final és anterior a la d'inici, ajustem la d'inici
        if (startDate && endDate && endDate < startDate) {
            startDateInput.value = endDateInput.value;
        }

        // Ajustem el valor màxim per la data d'inici
        startDateInput.max = endDateInput.value;
    });
  }
  
});


